
<template>
    <div>
        <mars-view class="lawyer-register"><top-bar :title="topBar.title" :bg-color="topBar.topBgColor" :text-color="topBar.fontColor" :no-blank="true" :show-home-icon="false" :no-left-nav="true"></top-bar><mars-image v-for="(val, idx) in imgList" :key="idx" mode="widthFix" :preview="false" class="lawyer-register-img" :src="val" :lazy-load="true"></mars-image><mars-view class="lawyer-register-bottom"><mars-view class="lawyer-register-button l-font-semibold" @click.native.stop="tapFn">
            授权客服电联，了解更多信息
        </mars-view></mars-view><model v-if="isShowModel" :info="modelText" @closeModel="close"></model></mars-view>
    </div>
</template>

<script>
import Base from '@baidu/base-util';
import Topbar from "../../components/common/topbar.vue";
import Model from "../../components/common/model.vue";
import { request } from '../../static/utils/request.js';
import { reqPathTo } from '../../static/utils/env';
export default {
  components: {
    'top-bar': Topbar,
    'model': Model
  },
  data() {
    return {
      topBar: {
        fontColor: '#000',
        title: '百度律临 律师会员',
        topBgColor: '#fff'
      },
      imgList: ['https://law-smartapp.cdn.bcebos.com/vip/vip-1.jpg', 'https://law-smartapp.cdn.bcebos.com/vip/vip-2.jpg', 'https://law-smartapp.cdn.bcebos.com/vip/vip-3.jpg'],
      modelText: {
        title: '',
        content: '',
        btnText: '确认'
      },
      isShowModel: false,
      passName: ''
    };
  },
  methods: {
    // 获取pass_name，之后迁移到B端小程序以后就不用请求
    getPassName() {
      request({
        url: '/bp/plugin/proxy?url=law:%2Fthemis%2Flaw%2Fuser%2Finfo'
      }).then(res => {
        const data = Base.get(res, 'data.data.data') || {};
        if (+data.code === 0) {
          this.passName = data.data && data.data.pass_name;
        }
      });
    },
    tapFn() {
      if (this.isLocking) {
        return;
      }
      this.isLocking = true;
      request({
        url: reqPathTo('genvip', {
          ...(this.passName && {
            pass_name: this.passName
          })
        }, '', 'bp/api/vip'),
        method: 'post'
      }).then(res => {
        this.isLocking = false;
        const data = res && res.data;
        if (+data.code === 0) {
          this.modelText.title = '您已成功提交会员开通意愿';
          this.modelText.content = '您已授权律临运营人员主动联系您沟通律临会员产品权益事宜，请您保持手机畅通，我们将在3天内联系您，感谢您对律临的信任！';
          this.isShowModel = true;
        } else {
          if (data.msg) {
            this.modelText.title = '';
            this.modelText.content = data.msg;
            this.isShowModel = true;
          } else {
            this.$api.showToast({
              title: '请求失败，请稍候重试',
              icon: 'none'
            });
          }
        }
      }).catch(() => {
        this.$api.showToast({
          title: '请求失败，请稍候重试',
          icon: 'none'
        });
        this.isLocking = false;
      });
    },
    close() {
      this.isShowModel = false;
    }
  },
  created() {
    (function () {
      this.getPassName();
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.lawyer-register {
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding-top: 44px;
  background: #17203f;
  position: relative;
}
.lawyer-register .lawyer-register-img {
  width: 100%;
  display: block;
}
.lawyer-register .lawyer-register-bottom {
  width: 100%;
  height: 1.49rem;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 52%);
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lawyer-register .lawyer-register-button {
  width: 100%;
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: center;
  margin: 0 0.17rem;
  background-image: linear-gradient(90deg, #f4e6c5 2%, #e2b96f 100%);
  border-radius: 0.22rem;
  font-size: 0.18rem;
  color: #543500;
  font-weight: 600;
  margin-top: 30px;
}
.lawyer-register::before {
  content: '';
  position: absolute;
  top: -300px;
  width: 100%;
  height: 300px;
  background: #17203f;
}

</style>
